import React, { useEffect, useState } from "react";
import axios from "axios";
import CategoryModal from "../../../layout/components/modal/CategoryModal";
import { toast } from "react-hot-toast";

export function SelectDropdown({ defaultSelected, label, endpoint, onChange, allowCreate = true }) {
  const apiEndpoint = process.env.REACT_APP_API_URL + endpoint;
  let searchTimeout = null;

  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [inputValue, setInputValue] = useState(defaultSelected ?? "");
  const [triggerModal, setTriggerModal] = useState(false);
  const [selectedInventory, setSelectedInventory] = useState(null);

  const fetchData = (searchString = "") => {
    axios
      .get(`${apiEndpoint}?name=${searchString}`)
      .then((res) => {
        setOptions(res.data.entities);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData(defaultSelected ?? "");
    setInputValue(defaultSelected ?? "");
  }, [defaultSelected]);

  useEffect(() => {
    if (options.length !== 0) {
      const g = options.find((item) => item.name === inputValue);

      setSelected(g);
      setInputValue(g?.name);
    }
  }, [options]);


  useEffect(() => {
    onChange(selected?.id);
  }, [selected, onChange]);

  const onFieldInput = (ev) => {
    clearTimeout(searchTimeout);
    const searchVal = ev.target.value;
    setInputValue(searchVal);
    searchTimeout = setTimeout(() => {
      fetchData(searchVal);
    }, 500);
  };

  const handleItemChange = (option) => {
    if (selected?.id === option.id) {
      setSelected(null);
      setInputValue("");
    } else {
      setSelected(option);
      setInputValue(option.name);
    }
    setShowDropdown(false);
  };

  const handleItemCreate = () => {
    axios
      .post(apiEndpoint, {
        name: inputValue,
        inventory: selectedInventory,
      })
      .then((res) => {
        setSelected(res.data);
        setInputValue(res.data.name);
        setShowDropdown(false);
        fetchData(inputValue);
        toast.success("دسته بندی تنظیم شد");
        onHide();
      })
      .catch((err) => {
        toast.success("مشکل در مشخص کردن دسته بندی");
      });
  };

  const onHide = () => {
    setTriggerModal(false);
    setSelectedInventory(null);
  };

  // console.log(options.find((item) => item.name === inputValue));

  return (
    <>
      {triggerModal && (
        <CategoryModal
          show={triggerModal}
          onHide={onHide}
          categoryName={inputValue}
          selectedInventory={selectedInventory}
          setSelectedInventory={setSelectedInventory}
          handleItemCreate={handleItemCreate}
        />
      )}

      <div className={"position-relative"}>
        {label && <label>{label}</label>}

        <input
          onClick={() => setShowDropdown(!showDropdown)}
          onInput={onFieldInput}
          type={"text"}
          value={inputValue}
          onChange={() => {}}
          className={"form-control"}
          placeholder={"جستجو..."}
        />

        {showDropdown && (
          <div
            className={
              "border rounded position-absolute zindex-5 bg-white w-100"
            }
            style={{ maxHeight: 150, overflowY: "auto", top: 65 }}
          >
            <ul className={"list-unstyled mb-0"}>
              {options.map((option) => (
                <li
                  onClick={() => handleItemChange(option)}
                  className={"border-top px-3 py-2 d-flex align-items-center"}
                  key={option.id}
                >
                  <input
                    onChange={() => handleItemChange(option)}
                    checked={selected?.id === option.id}
                    type={"checkbox"}
                  />{" "}
                  <label className={"mb-0 ml-2"}>{option.name}</label>
                </li>
              ))}

              {inputValue !== "" && allowCreate &&
                options.every((item) => item.name !== inputValue) && (
                  <li
                    onClick={() => setTriggerModal(true)}
                    className="border-top px-3 py-2 d-flex align-items-center cursor-pointer"
                  >
                    ایجاد دسته بندی
                  </li>
                )}
            </ul>
          </div>
        )}
      </div>
    </>
  );
}
